var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
var TemplateTicketDesign = /** @class */ (function (_super) {
    __extends(TemplateTicketDesign, _super);
    function TemplateTicketDesign(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.data = new TemplateTicketDesignGraphic();
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        TemplateTicketDesign.buildFromJson(_this, obj);
        return _this;
    }
    TemplateTicketDesign.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'data') {
                        instance.data = new TemplateTicketDesignGraphic(json[prop]);
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    TemplateTicketDesign.prototype.exportToJson = function () {
        var JSONTemplateTicketDesign = {};
        JSONTemplateTicketDesign.data = this.data.exportToJson();
        if (this.type) {
            JSONTemplateTicketDesign.type = this.type;
        }
        if (this.name) {
            JSONTemplateTicketDesign.name = this.name;
        }
        if (this.uid) {
            JSONTemplateTicketDesign.uid = this.uid;
        }
        return JSONTemplateTicketDesign;
    };
    return TemplateTicketDesign;
}(Model));
export { TemplateTicketDesign };
var TemplateTicketDesignGraphic = /** @class */ (function (_super) {
    __extends(TemplateTicketDesignGraphic, _super);
    function TemplateTicketDesignGraphic(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        /** Représente le ticket en lui même **/
        _this.layers = [];
        _this.size = { w: 0, h: 0 };
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        TemplateTicketDesignGraphic.buildFromJson(_this, obj);
        return _this;
    }
    TemplateTicketDesignGraphic.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'layers') {
                        for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                            var subProp = _a[_i];
                            instance.layers.push(new Layer(subProp));
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    TemplateTicketDesignGraphic.prototype.exportToJson = function () {
        var JSONTTDG = {};
        JSONTTDG['size'] = this.size;
        if (this.layers.length > 0) {
            JSONTTDG['layers'] = [];
            for (var _i = 0, _a = this.layers; _i < _a.length; _i++) {
                var layer = _a[_i];
                JSONTTDG['layers'].push(layer.exportToJson());
            }
        }
        return JSONTTDG;
    };
    return TemplateTicketDesignGraphic;
}(Model));
export { TemplateTicketDesignGraphic };
var Layer = /** @class */ (function (_super) {
    __extends(Layer, _super);
    function Layer(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        /** elements[0] first write **/
        _this.elements = [];
        _this.background = undefined;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Layer.buildFromJson(_this, obj);
        return _this;
    }
    Layer.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'elements') {
                        for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                            var subProp = _a[_i];
                            if (subProp.type === 'text') {
                                instance.elements.push(new Text(subProp));
                            }
                            else if (subProp.type === 'image') {
                                instance.elements.push(new Image(subProp));
                            }
                            else if (subProp.type === 'box') {
                                instance.elements.push(new Box(subProp));
                            }
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Layer.prototype.exportToJson = function () {
        var JSONLayer = {};
        if (this.background)
            JSONLayer['background'] = this.background;
        if (this.elements.length > 0) {
            JSONLayer['elements'] = [];
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var element = _a[_i];
                JSONLayer['elements'].push(element.exportToJson());
            }
        }
        return JSONLayer;
    };
    return Layer;
}(Model));
export { Layer };
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        /** Base64 **/
        _this.data = '';
        /** Pourcentage **/
        _this.position = { x: 0, y: 0 };
        _this.size = { w: 0, h: 0 };
        _this.direction = 0;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Image.buildFromJson(_this, obj);
        return _this;
    }
    Image.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    instance[prop] = json[prop];
                }
            }
        }
    };
    Image.prototype.exportToJson = function () {
        return {
            data: this.data,
            type: 'image',
            size: this.size,
            position: this.position,
            direction: this.direction
        };
    };
    return Image;
}(Model));
export { Image };
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.data = 'Lorem ipsum';
        _this.font = 1;
        _this.fillColor = "black";
        _this.fontSize = -1;
        _this.color = "black";
        _this.direction = 0;
        _this.center = false;
        _this.bold = false;
        /** Pourcentage **/
        _this.position = { x: 0, y: 0 };
        _this.size = { w: 0, h: 0 };
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Text.buildFromJson(_this, obj);
        return _this;
    }
    Text.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'direction' || prop === 'font') {
                        instance[prop] = parseInt(json[prop]);
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Text.prototype.exportToJson = function () {
        return {
            data: this.data,
            font: this.font,
            direction: this.direction,
            position: this.position,
            size: this.size,
            center: this.size,
            bold: this.size,
            type: 'text',
        };
    };
    return Text;
}(Model));
export { Text };
var Box = /** @class */ (function (_super) {
    __extends(Box, _super);
    function Box(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.direction = 0;
        _this.borderSize = 0;
        _this.fill = false;
        /** Pourcentage **/
        _this.position = { x: 0, y: 0 };
        _this.size = { w: 0, h: 0 };
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Box.buildFromJson(_this, obj);
        return _this;
    }
    Box.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    instance[prop] = json[prop];
                }
            }
        }
    };
    Box.prototype.exportToJson = function () {
        return {
            direction: this.direction,
            borderSize: this.borderSize,
            fill: this.fill,
            size: this.size,
            position: this.position,
            type: 'box',
        };
    };
    return Box;
}(Model));
export { Box };
//# sourceMappingURL=TemplateTicketDesign.js.map